import {createElement, PropTypes} from 'rlink-react';
import {connect} from 'react-redux';

import BuildContext from 'rlink-router/BuildContext';
import MountRootComponent from 'rlink-router/MountRootComponent.jsx';
import getCurrentRouteState from 'rlink-router/getCurrentRouteState';
import getLoadedMessages from 'rlink-router/getLoadedMessages';
import getOpenFlyouts from 'rlink-router/getOpenFlyouts';
import getOpenModals from 'rlink-router/getOpenModals';
import popModal from 'rlink-router/actions/popModal';
import getNextTransition from 'rlink-router/getNextTransition';

function mapStateToProps (state, {store, buildContext}) {
  let {routing, tooltip} = store.getState();
  let {
    mountedContent,
    params = {},
  } = getCurrentRouteState(routing);
  let {locale = buildContext.defaultLocale} = params;
  return {
    buildContext,
    store,
    locale,
    mountedContent,
    messages: getLoadedMessages(routing, locale),
    flyouts: getOpenFlyouts(routing),
    tooltip,
    modals: getOpenModals(routing),
    nextTransition: getNextTransition(routing),
  };
}

const mapDispatchToProps = {
  onCloseModal: popModal,
};

const ConnectedMountRootComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MountRootComponent);

ConnectedMountRootComponent.propTypes = {
  store: PropTypes.shape({
    getState: PropTypes.func,
  }),
  buildContext: PropTypes.instanceOf(BuildContext),
};

export default ConnectedMountRootComponent;



// WEBPACK FOOTER //
// ./lib/rlink-router/ConnectedMountRootComponent.jsx